import { useAdminReplyMutation, useApproveAndReplyAdminMutation } from "@/stores/redux/api/reviewsApi";
import { reviewsStore } from "@/stores/ReviewsStore";
import { addNotification } from "@/utils/addNotification";

import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { SaveButton } from "../button/SaveEditCancel/SaveButton";
import { InputAndLabelTextBox } from "../input/InputAndLabelTextBox/InputAndLabelTextBox";
import { DefaultLoader } from "../loaders/DefaultLoader/DefaultLoader";
import { TextAreaWithScrollBar } from "../textarea/TextAreaWithScrollBar/TextAreaWithScrollBar";
import styles from "./ReplyForm.module.css";

export const ReplyForm = observer(() => {
  const [viewSend, setViewSend] = useState(false);
  const [sending, setSending] = useState(false);
  const [adminReply, { isLoading }] = useAdminReplyMutation();
  const [approveAndReplyAdmin, { isLoading: isLoad }] = useApproveAndReplyAdminMutation();

  useEffect(() => {
    if (!sending) return;

    const handleReply = async () => {
      const result =
        reviewsStore.entity_type === "reply"
          ? await approveAndReplyAdmin({ id: reviewsStore.parent_id!, text: reviewsStore.text })
          : await adminReply({
              review_id: reviewsStore.parent_id!,
              text: reviewsStore.text,
              name: reviewsStore.senderName!,
            });

      if (result.data?.review) {
        addNotification({
          type: "success",
          message: "Ответ отправлен",
        });

        if (reviewsStore.entity_type === "reply") {
          reviewsStore.modal.isHide();
        }
      } else {
        addNotification({
          type: "error",
          message: "Не удалось отправить ответ",
        });
      }
      setSending(false);
      reviewsStore.clearReply();
    };

    handleReply();
  }, [sending]);

  useEffect(() => {
    reviewsStore.setWait(isLoad);
  }, [isLoad]);

  return (
    <>
      {isLoading && <DefaultLoader elementIsReady={false} />}
      <div className="flex flex-col z-2 gap-2 relative w-full rounded-inherit !mt-2" id="replyForm">
        <div className="flex flex-col gap-2 items-start w-full">
          <div className="flex flex-col gap-[0px] items-start w-full">
            <span className="!ml-[6px] text-[12px] text-[rgba(255,255,255,0.5)]">Имя Администратора</span>
            <InputAndLabelTextBox
              labelText="Видимое имя для посетителя"
              className="!w-full"
              idAndForHTML="name"
              props={{
                defaultValue: "",
                placeholder: "",
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  reviewsStore.setSenderName(e.target.value);
                },
              }}
            />
          </div>
        </div>
        <div
          className={clsx(
            `flex 
                flex-col
                gap-[2px]
                 w-full  rounded-xl`,
          )}
        >
          <div
            className={clsx(
              `flex 
                flex-col
                gap-1
                h-auto w-full`,
              styles.inputBox,
            )}
          >
            <span className="!ml-[6px] text-[12px] text-[rgba(255,255,255,0.5)] flex flex-row gap-[4px]">
              Сообщение
            </span>
            <TextAreaWithScrollBar
              placeholder="Введите сообщение..."
              backValue={(e) => {
                setViewSend(e.length > 0);
                reviewsStore.setText(e);
              }}
            ></TextAreaWithScrollBar>
          </div>
          {viewSend && (
            <div className="flex flex-row flex-wrap gap-2 justify-end items-center !mt-2">
              <section className={styles.buttonSend}>
                <SaveButton onClick={() => setSending(true)}>Отправить</SaveButton>
              </section>
            </div>
          )}
        </div>
      </div>
    </>
  );
});
